export default {
    stickers: {
        title: 'Autocollants',
        stickerOpacity: 'Opacité des autocollants',
        stickerColor: "Couleur de l'autocollant",
        shapes: {
            title: 'Formes',
            rectangle: 'Rectangle',
            circle: 'Cercle',
            triangle: 'Triangle ',
        },
        emojis: {
            title: 'Emojis',
        },
    },
};
